export interface Electron {
    ipcRenderer: any;
    remote: any;
}

export class ElectronUtils {
    static readonly electron: Electron | undefined = (window as any).electron;
}
